import AddStinger from "@/components/Dam/OnBoardThreadUser";
import CreateThread from "@/components/Dam/CreateThread";

const Dam = () => {
  return (
    <>
      <div className="mb-5">
        <CreateThread />
      </div>
      <div className="mb-5">
        <AddStinger />
      </div>
    </>
  );
};

export default Dam;
